import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import HomePageTwo from "../page/home2/HomePageTwo";
import { Helmet } from 'react-helmet'; 
function HomePageTwoLayout() {
  return (
    <>
    {/* Seo  */}
        <Helmet>        
        <title>Genius Fixers | The Best IT Support Company - Software House</title>
        <link rel='canonical' href='https://www.geniusfixers.com/' />       
        <meta
            name='description'
            content='Genius Fixers | The Best IT support company is a software development and IT company with the best software management system.'
        />
        <meta
            name='keywords'
            content='software house, IT company, software development, software management system'
        />
        </Helmet>
    {/* Seo  */}

      <div className="background-image-unset bg-white">
        <Header />
        <HomePageTwo />
        <Footer />
      </div>
    </>
  );
}

export default HomePageTwoLayout;
